var _path, _circle, _path2, _circle2, _circle3, _path3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 238,
    viewBox: "0 0 204 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 118.511C69.5 116.177 79 115.974 91 118.511C103.756 121.208 118 130.974 118 140.974C118 149.974 116.586 162.677 104 165.474C95 167.474 84.5002 167.511 76.0001 170.511C66.28 173.941 58.0001 184.511 58.0001 199.511C58.0001 208.011 64.0001 219.011 76.0001 222.011C88.1296 225.043 127.667 221.344 147.5 222.011",
    stroke: "black",
    strokeWidth: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 35.4736,
    r: 15,
    stroke: "black",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86.9737C38.2 91.7738 36.9444 90.9737 40.5 86.9737C44.5 82.4738 66 56.4736 69.5 41.9736C73.7382 24.4155 66.8572 14.2492 55 7.47363C44.5 1.47364 28.1354 1.54406 18.5 7.4736C5.50001 15.4736 3.00001 25.9736 3 36.4736C2.99999 49.4736 31 80.9737 35 86.9737Z",
    stroke: "black",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 120.474,
    r: 17,
    stroke: "black",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 132.947,
    r: 15,
    stroke: "black",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.5 184.447C167.7 189.247 166.444 188.447 170 184.447C174 179.947 195.5 153.947 199 139.447C203.238 121.889 196.357 111.723 184.5 104.947C174 98.9473 157.635 99.0177 148 104.947C135 112.947 132.5 123.447 132.5 133.947C132.5 146.947 160.5 178.447 164.5 184.447Z",
    stroke: "black",
    strokeWidth: 6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 217.947,
    r: 17,
    stroke: "black",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapLogo);
export default __webpack_public_path__ + "static/media/RoadmapLogo.8522cbf9d9a01b199b711e07a6182b98.svg";
export { ForwardRef as ReactComponent };